export const variants = {
  light: {
    hoverColor: 'hero.spinach',
    checked: {
      background: 'secondary.egg',
      border: 'border.dark',
      text: 'text.primary',
      iconBackground: 'border.dark',
    },
    unchecked: {
      background: 'border.fur',
      opacity: 0.2,
      border: 'border.dark',
      text: 'text.primary',
      iconBackground: 'border.dark',
    },
  },
  dark: {
    hoverColor: 'hero.spinach',
    checked: {
      background: 'background.dark',
      border: 'border.dark',
      text: 'text.lightest',
      iconBackground: 'background.lightest',
    },
    unchecked: {
      background: 'background.lightest',
      border: 'border.dark',
      text: 'text.primary',
      iconBackground: 'border.dark',
    },
  },
  sea: {
    hoverColor: 'secondary.sea',
    checked: {
      background: 'secondary.sea',
      opacity: 0.1,
      border: 'secondary.sea',
      text: 'text.primary',
      iconBackground: 'background.lightest',
    },
    unchecked: {
      background: 'background.lightest',
      border: 'secondary.sea',
      text: 'text.primary',
      iconBackground: 'background.lightest',
    },
  },
};
